// ----------------------------------------------------------------------------
// Component: Trademarks
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// Styles
import './_trademarks.scss';

const TRADEMARK_LINK   = '#trademark-link';

document.addEventListener('DOMContentLoaded', function() {
  const trademarkLink = document.querySelector(TRADEMARK_LINK);

  if(trademarkLink) {
    trademarkLink.addEventListener('click', (event) => {
      dataLayer.push({'event': 'data_opt_out'});
    });
  }
});
